import styled from 'styled-components'

export const Wrapper = styled.div`
  .progress {
    position: absolute;
    top: 2px;
    left: 2px;
    height: 100%;
    z-index: -1;
    border-radius: 3px;
  }

  .progress-label {
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    line-height: 200px;
    color: white;
  }

  .label {
    color: white;
    font-size: 23px;
    opacity: 0.8;
    padding: 10px;
    text-align: center;
    justify-content: center;
    margin-top: 55px;
  }
`

export const WrapperNoUI = styled.div`
  height: 100%;
  width: 100%;
  > div {
    background-color: rgba(255, 255, 255, 0.3);
  }
`
